import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  isTreeUpdated: boolean;
  treeValueChange: Subject<boolean> = new Subject<boolean>();
  apiUrl = environment.champsApiUrl;
  authUrl = environment.authUrl;

  constructor(private http: HttpClient) {
    this.isTreeUpdated = false;
    this.treeValueChange.subscribe((value) => {
      this.isTreeUpdated = value;
    });
  }

  trackTreeUpdate(): void {
    this.treeValueChange.next(!this.isTreeUpdated);
  }
  getbaseLineTree(userId: string): Observable<any> {
    const params = new HttpParams()
      .set('userId', `${userId}`);
    return this.http.get<any>(`${this.apiUrl}/BaseLine/GetBaseLineTree`, { params });
  }

  /*
 * {
"tenantId": 1,
"baselineSimulationType": 1,
"typeId": 2,
"baselineId": 2,
"baselineName": "North Korea",
"baselineAbbr": "NK",
"baselineYear": 2000,
"simulationId": 3,
"simulationName": "South Korea Horizontal Growth",
"simulationAbbr": "SKHG",
"simulationYear": 2019,
"lastLoginTime": "2021-01-30T11:10:26.65+00:00",
"baselineCreatedBy": "MANOJ",
"simulationCreatedBy": "MANOJ"
}
 */
  getAccountDetails(userId: string): Observable<any> {
    const params = new HttpParams()
      .set('userId', `${userId}`);
    return this.http.get<any>(`${this.apiUrl}/Account/GetLoggedInUserProfile`, { params });
  }

  saveAccountDetails(obj: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/Account/SaveTypeBaselineSimulation`, obj);
  }

  getLoginInfo(userId: string): Observable<any> {
    const params = new HttpParams()
      .set('userId', `${userId}`);
    return this.http.get<any>(`${this.apiUrl}/Login/GetLoggedInUser`, { params });
  }


  ///////////////////////////////////////////////
  getResource(lang = 'en') {
    if(!lang) lang='en';
    let url = 'assets/resource/' + lang + '/resource.json?dt='+ new Date();
    return this.http.get<any>(url);
  }

  getCurrentLoggedInUser(){
    return this.http.get<any>(`${this.authUrl}`)
  }

}